import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { changeEaState } from '@store/actions/eaAction';
import PropTypes from 'prop-types';

const SuitabilityHeader = props => {
  const { title } = props;
  const { changeOrientation, isPortrait } = $hooks.useDevice();
  const dispatch = useDispatch();

  const handleMenuOn = () => {
    // lnb 노출
    dispatch(
      changeEaState({
        type: 'isShowLnb',
        data: true,
      }),
    );
  };

  const handleOnChangeDisplay = () => {
    const toggledOrientation = isPortrait ? 'landscape' : 'portrait';
    changeOrientation(toggledOrientation);
  };

  return (
    <header className="con-header">
      {isPortrait && (
        <button type="botton" className="btn-nav" onClick={handleMenuOn}>
          메뉴
        </button>
      )}
      <h1 className="page-tit2">{title}</h1>
      <button className="btn-s blue2 side-r" onClick={handleOnChangeDisplay}>
        <span className="ico ico-mode"></span>
        {isPortrait ? '가로 화면 전환' : '세로 화면 전환'}
      </button>
    </header>
  );
};
SuitabilityHeader.propTypes = {
  // 제목
  title: PropTypes.string,
};
SuitabilityHeader.defaultProps = {
  title: '',
};
export default memo(SuitabilityHeader);
